module.exports = __webpack_public_path__ + "img/process-7.3419cb54.jpg";